import React, { Fragment, useState } from 'react';
import { Badge, Button, Card, CardBody, CardTitle } from 'reactstrap';
import moment from 'moment';
import { faArrowDown, faTicketAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IntlMessages from '../../../../../helpers/IntlMessages';
const ConversationSummary = ({
  conversationSummary,
  isLoading,
  tickettoggle,
  handleStatusSubmit,
  selectedChat,
}) => {
  const [loading, setLoading] = useState(isLoading);
  useState(() => {
    if (conversationSummary !== null) {
      setLoading(false);
    }
  }, [conversationSummary]);
  function generateRandomColor() {
    var arr = [
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'danger',
      'light',
      'dark',
    ];
    return arr[Math.floor(Math.random() * arr.length)];
  }
  function secondsToHms(d) {
    d = Number(d);
    var h = Math.round(d / 3600);
    var m = Math.round((d % 3600) / 60);
    var s = Math.round((d % 3600) % 60);
    var seconds = '';
    var minutes = m;
    var hours = h;
    if (m !== 0 && s > 1) {
      const min = m + 1;
      minutes = min;
    } else {
      seconds = s + (s == 1 ? ' second' : ' seconds');
    }
    var hDisplay = hours > 0 ? hours + (hours == 1 ? ' hour ' : ' hours ') : '';
    var mDisplay =
      minutes > 0 ? minutes + (minutes == 1 ? ' minute ' : ' minutes ') : '';
    //var sDisplay = s + (s == 1 ? " second" : " seconds");
    return hDisplay + mDisplay + (m > 0 && s == 0 ? '' : seconds);
  }

  // function secondsToHms(given_seconds) {
  //     var timeString = "";
  //     var dateObj = new Date(given_seconds * 1000);
  //     console.log(dateObj);
  //     var hours = dateObj.getUTCHours();
  //     var minutes = dateObj.getUTCMinutes();
  //     var seconds = dateObj.getSeconds();
  //     console.log(hours, Math.round(hours), minutes, Math.round(minutes), seconds, Math.round(seconds));
  //     timeString = (hours !== 0 ? hours.toString() + (hours == 1 ? " hour, " : " hours ") : "")
  //         + (minutes !== 0 ? minutes.toString() + (minutes == 1 ? " minute, " : " minutes ") : "")
  //         + (seconds !== 0 ? seconds.toString() + (seconds == 1 ? " second" : " seconds") : "");

  //     return timeString;
  // }

  function getExpression(sentiment) {
    var svg;
    if (sentiment === 'Positive') {
      svg = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="green"
          viewBox="0 0 512.000000 512.000000"
          preserveAspectRatio="xMidYMid meet"
          fill="none"
        >
          <g
            transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            stroke="none"
          >
            <path d="M2321 5110 c-497 -48 -990 -251 -1376 -565 -114 -92 -294 -274 -384 -387 -229 -287 -417 -675 -495 -1023 -49 -218 -60 -325 -60 -575 0 -250 11 -357 60 -575 79 -355 272 -749 509 -1040 92 -114 274 -294 387 -384 287 -229 675 -417 1023 -495 218 -49 325 -60 575 -60 250 0 357 11 575 60 261 58 603 204 828 353 389 259 688 599 893 1016 125 255 196 484 241 775 24 161 24 539 0 700 -45 291 -116 520 -241 775 -134 272 -283 480 -498 692 -211 209 -404 346 -673 478 -252 124 -486 197 -765 240 -126 19 -468 27 -599 15z m594 -339 c240 -40 419 -98 640 -206 570 -280 1011 -818 1170 -1431 54 -207 69 -331 69 -574 0 -243 -15 -367 -69 -574 -159 -613 -600 -1151 -1170 -1431 -221 -108 -397 -165 -645 -207 -180 -31 -520 -31 -700 0 -248 42 -424 99 -645 207 -570 280 -1011 818 -1170 1431 -54 207 -69 331 -69 574 0 243 15 367 69 574 55 212 170 470 290 651 382 574 972 932 1660 1005 129 14 434 4 570 -19z" />
            <path d="M1663 3662 c-109 -39 -178 -112 -210 -221 -29 -102 4 -228 82 -306 122 -121 328 -121 450 0 121 122 121 328 0 450 -82 81 -219 114 -322 77z" />
            <path d="M3263 3662 c-109 -39 -178 -112 -210 -221 -41 -144 35 -304 176 -370 45 -21 71 -26 131 -26 129 0 234 67 289 184 54 115 27 264 -64 356 -82 81 -219 114 -322 77z" />
            <path d="M1124 2468 c35 -458 268 -859 646 -1110 150 -99 319 -168 510 -209 150 -32 410 -32 560 0 388 83 707 298 922 621 133 201 215 445 234 698 l7 92 -160 0 -160 0 -6 -75 c-20 -238 -105 -450 -250 -630 -125 -153 -322 -292 -502 -353 -229 -78 -501 -78 -730 0 -180 61 -377 200 -502 353 -145 180 -230 392 -250 630 l-6 75 -160 0 -160 0 7 -92z" />
          </g>
        </svg>
      );
    } else if (sentiment === 'Neutral') {
      svg = (
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          className="yellow"
          viewBox="0 0 512.000000 512.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <g
            transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            stroke="none"
          >
            <path d="M2370 5113 c-379 -36 -661 -116 -980 -278 -378 -193 -717 -497 -965 -865 -104 -156 -232 -419 -294 -605 -49 -150 -89 -321 -113 -490 -17 -118 -17 -512 0 -630 42 -295 120 -553 242 -800 137 -280 272 -468 494 -691 221 -220 412 -357 681 -489 188 -92 309 -137 500 -185 500 -126 1002 -102 1490 71 150 53 408 183 540 271 302 202 573 480 769 788 72 113 188 353 235 486 235 662 194 1372 -115 1993 -124 250 -263 447 -458 648 -214 222 -430 379 -711 518 -296 146 -572 225 -900 255 -102 9 -333 11 -415 3z m545 -342 c628 -106 1158 -448 1511 -977 179 -267 296 -573 351 -909 24 -153 24 -497 0 -650 -108 -668 -474 -1222 -1042 -1580 -243 -153 -537 -261 -850 -312 -154 -24 -497 -24 -650 1 -657 107 -1198 456 -1557 1006 -168 257 -281 557 -335 885 -24 153 -24 497 0 650 81 497 291 912 636 1255 382 381 862 605 1401 654 108 10 418 -4 535 -23z" />
            <path d="M1402 3492 c-94 -34 -178 -123 -203 -215 -19 -69 -7 -175 27 -236 59 -109 153 -165 279 -165 94 -1 157 23 218 82 132 127 139 314 16 447 -87 94 -220 128 -337 87z" />
            <path d="M3530 3501 c-90 -30 -174 -103 -212 -186 -30 -68 -30 -180 0 -247 29 -66 102 -141 165 -169 78 -35 192 -34 269 4 71 35 130 101 159 176 27 73 23 185 -10 249 -57 110 -153 173 -274 178 -40 2 -83 0 -97 -5z" />
            <path d="M1507 1786 c-72 -26 -107 -76 -107 -153 0 -57 26 -105 72 -133 32 -20 53 -20 1088 -20 1035 0 1056 0 1088 20 101 62 97 213 -8 274 -35 21 -46 21 -1065 23 -851 2 -1037 0 -1068 -11z" />
          </g>
        </svg>
      );
    } else if (sentiment === 'Negative') {
      svg = (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="red"
          viewBox="0 0 512.000000 512.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <g
            transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            stroke="none"
          >
            <path d="M2405 5014 c-240 -19 -495 -74 -704 -153 -840 -317 -1436 -1055 -1573 -1946 -28 -183 -30 -501 -5 -680 76 -534 320 -1026 697 -1406 372 -375 855 -619 1385 -701 198 -30 512 -30 710 0 522 81 997 317 1365 681 385 380 629 860 712 1396 30 198 30 512 0 710 -124 805 -615 1480 -1343 1845 -241 122 -485 197 -758 235 -113 15 -392 26 -486 19z m356 -314 c397 -39 776 -186 1095 -426 98 -73 275 -244 360 -346 312 -374 494 -877 494 -1368 0 -410 -130 -844 -355 -1180 -220 -329 -517 -589 -865 -757 -497 -240 -1073 -277 -1600 -103 -318 105 -580 264 -819 495 -190 184 -332 377 -442 601 -355 727 -272 1589 217 2240 73 98 244 275 346 360 428 358 1014 538 1569 484z" />
            <path d="M1710 3471 c-95 -31 -177 -108 -205 -192 -21 -63 -21 -146 1 -212 23 -69 109 -155 179 -180 150 -52 316 16 385 158 36 74 34 190 -3 262 -56 107 -146 166 -262 170 -38 1 -81 -1 -95 -6z" />
            <path d="M3226 3465 c-77 -29 -130 -78 -173 -160 -37 -69 -38 -186 -3 -260 69 -142 235 -210 385 -158 70 25 156 111 179 180 50 151 -12 311 -148 380 -63 33 -179 41 -240 18z" />
            <path d="M2460 2403 c-343 -23 -649 -161 -886 -398 -128 -128 -244 -302 -244 -365 1 -43 37 -108 72 -130 42 -25 119 -27 160 -2 17 9 58 60 94 113 118 180 307 332 502 405 139 52 237 69 402 69 165 0 263 -17 402 -69 197 -74 384 -225 504 -407 71 -108 100 -131 169 -131 110 0 180 104 140 207 -24 65 -128 207 -220 300 -235 240 -524 375 -865 405 -112 10 -136 10 -230 3z" />
          </g>
        </svg>
      );
    }
    return svg;
  }
  //console.log(conversationSummary);
  return (
    <Fragment>
      {loading ? (
        <div
          className="loading"
          style={{ position: 'absolute', top: '150px' }}
        />
      ) : (
        conversationSummary !== null && (
          <Fragment>
            <div className="icon-row-item mb-4">
              <Card>
                <CardBody>
                  <CardTitle>
                    {' '}
                    <IntlMessages id="content.customersentiment" />{' '}
                  </CardTitle>
                  {conversationSummary?.customer_sentiment && (
                    <div className="d-flex flex-row pb-1">
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          <svg
                            version="1.0"
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 348.000000 348.000000"
                            preserveAspectRatio="xMidYMid meet"
                          >
                            <g
                              transform="translate(0.000000,348.000000) scale(0.100000,-0.100000)"
                              fill="#000000"
                              stroke="none"
                            >
                              <path d="M2063 2603 c-74 -153 -181 -372 -238 -488 -56 -115 -202 -415 -325 -665 -249 -510 -257 -532 -225 -633 76 -244 412 -269 520 -40 9 18 77 297 151 620 74 324 180 781 234 1017 107 461 108 466 49 466 -30 0 -33 -5 -166 -277z m-427 -1594 c53 -50 66 -101 40 -164 -20 -47 -69 -75 -130 -75 -43 0 -53 4 -87 39 -47 47 -55 101 -22 164 35 68 144 88 199 36z" />
                              <path d="M1676 2609 c-11 -32 -21 -391 -11 -398 6 -5 29 -11 53 -15 l43 -6 98 202 98 203 -31 7 c-17 4 -79 10 -138 14 -88 6 -108 4 -112 -7z" />
                              <path d="M1391 2595 c-166 -30 -307 -78 -464 -156 -107 -54 -247 -145 -247 -161 0 -18 148 -238 160 -238 6 0 45 17 88 39 153 76 297 116 477 131 65 5 120 12 123 14 6 6 -17 367 -24 378 -7 10 -23 9 -113 -7z" />
                              <path d="M2262 2363 c-17 -76 -42 -184 -55 -240 l-25 -103 49 -35 c27 -19 53 -35 58 -35 12 0 271 398 271 416 0 14 -228 134 -255 134 -7 0 -24 -54 -43 -137z" />
                              <path d="M2546 2069 l-166 -201 67 -76 c109 -126 203 -280 253 -420 13 -34 27 -65 32 -68 15 -10 568 216 568 232 0 39 -130 261 -229 389 -85 111 -278 299 -348 338 -7 4 -76 -71 -177 -194z" />
                              <path d="M466 2094 c-99 -106 -174 -209 -244 -333 -67 -120 -136 -280 -130 -306 2 -10 27 -27 61 -40 100 -41 90 -45 140 47 25 46 69 117 98 158 59 84 230 264 290 305 21 15 39 32 39 38 0 13 -152 194 -169 202 -9 3 -40 -22 -85 -71z" />
                              <path d="M3057 1273 l-298 -86 8 -76 c17 -160 5 -423 -23 -496 -6 -14 36 -15 362 -13 l369 3 -1 160 c-2 172 -18 303 -59 460 -26 100 -40 136 -53 134 -4 0 -141 -39 -305 -86z" />
                              <path d="M35 1268 c-31 -143 -42 -370 -26 -517 16 -151 16 -151 61 -151 l37 0 6 163 c5 157 26 293 62 411 24 78 23 80 -49 99 -82 22 -85 21 -91 -5z" />
                            </g>
                          </svg>
                        </p>
                      </div>
                      <div className="pl-3 pr-2">
                        <p className="mb-0" style={{ marginLeft: '1px' }}>
                          {conversationSummary?.customer_sentiment}
                        </p>
                      </div>
                      <div className="pl-3 pr-2">
                        <p className="mb-0 sentiments">
                          {getExpression(
                            conversationSummary?.customer_sentiment
                          )}
                        </p>
                      </div>
                    </div>
                  )}
                  <div className="d-flex flex-row pb-1">
                    <div className="pl-3 pr-2">
                      <p className="mb-0 ">
                        <svg
                          version="1.0"
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 239.000000 211.000000"
                          preserveAspectRatio="xMidYMid meet"
                        >
                          <g
                            transform="translate(0.000000,211.000000) scale(0.100000,-0.100000)"
                            fill="#000000"
                            stroke="none"
                          >
                            <path d="M1080 2099 c-443 -28 -823 -259 -990 -604 -66 -136 -84 -212 -84 -360 0 -93 5 -137 22 -197 43 -153 107 -265 215 -375 l60 -61 -97 -242 c-53 -133 -95 -244 -93 -247 3 -2 155 41 339 97 l335 100 94 -24 c251 -66 487 -58 740 24 566 185 872 659 733 1137 -45 156 -123 280 -253 405 -262 253 -613 372 -1021 347z m320 -194 c350 -57 654 -279 763 -555 117 -300 -2 -623 -306 -829 -71 -48 -241 -127 -327 -151 -100 -28 -249 -50 -336 -50 -90 0 -226 23 -322 56 l-74 24 -186 -55 c-103 -30 -190 -55 -194 -55 -3 0 9 39 29 88 19 48 43 108 53 133 l19 46 -65 52 c-233 187 -323 455 -239 717 36 116 88 197 190 299 244 242 603 343 995 280z" />
                            <path d="M791 1404 c-38 -27 -51 -74 -51 -186 0 -157 26 -188 161 -196 l81 -5 -5 -34 c-11 -67 -35 -86 -129 -107 -15 -4 -35 -17 -44 -31 -15 -23 -15 -27 0 -50 14 -21 24 -25 65 -25 68 0 162 49 200 104 48 69 56 114 54 294 -2 243 -9 252 -195 252 -89 0 -119 -4 -137 -16z" />
                            <path d="M1307 1400 c-34 -27 -47 -76 -46 -180 1 -155 29 -190 159 -198 90 -5 94 -10 65 -78 -15 -35 -61 -64 -105 -64 -22 0 -70 -41 -70 -60 0 -25 41 -50 83 -50 56 0 159 50 192 94 52 68 59 107 59 299 -1 250 -6 257 -197 257 -100 0 -118 -3 -140 -20z" />
                          </g>
                        </svg>
                      </p>
                    </div>
                    <div className="pl-3 pr-2">
                      <p className="mb-0 text-left">
                        {conversationSummary?.summary
                          ? conversationSummary.summary
                          : conversationSummary?.response
                            ? conversationSummary.response
                            : ''}
                      </p>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className="icon-row-item mb-4">
              <Card>
                <CardBody>
                  <CardTitle>
                    {' '}
                    <IntlMessages id="content.conversationinsights" />{' '}
                  </CardTitle>
                  {conversationSummary?.conversation_timing && (
                    <div className="d-flex flex-row pb-1">
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          <i className="demo-icon iconsminds-clock"></i>
                        </p>
                      </div>
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          {moment(
                            conversationSummary.conversation_timing.Start
                          ).format('dddd, MMMM DD YYYY')}{' '}
                          {moment(
                            conversationSummary.conversation_timing.Start
                          ).format('h:mm a')}
                        </p>
                      </div>
                    </div>
                  )}
                  {conversationSummary?.conversation_timing && (
                    <div className="d-flex flex-row pb-1">
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          <i className="demo-icon iconsminds-timer"></i>
                        </p>
                      </div>
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          {conversationSummary.conversation_timing.duration == 0
                            ? '0 active time'
                            : secondsToHms(
                                conversationSummary.conversation_timing.duration
                              ) + ' active time'}{' '}
                        </p>
                      </div>
                    </div>
                  )}
                  {conversationSummary?.topics_discussed && (
                    <div className="d-flex flex-row pb-1">
                      <div className="pl-3 pr-2">
                        <p className="mb-0 ">
                          <i className="demo-icon iconsminds-books"></i>
                        </p>
                      </div>
                      <div className="pl-3 pr-2 mb-2">
                        {conversationSummary.topics_discussed.map(
                          (tag, index) => {
                            return (
                              <Fragment key={index}>
                                {' '}
                                <Badge color={generateRandomColor()}>
                                  {tag}
                                </Badge>{' '}
                              </Fragment>
                            );
                          }
                        )}
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>
            </div>

            <div className="icon-row-item mb-4">
              <Card>
                <CardBody>
                  <CardTitle>
                    {' '}
                    <IntlMessages id="content.followups" />{' '}
                  </CardTitle>
                  <div className="consummary-followup">
                    {conversationSummary.unanswered_question !== undefined &&
                    conversationSummary.unanswered_question
                      .has_unanswered_question ? (
                      <div className="con-followuup-item">
                        <svg
                          version="1.0"
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          viewBox="0 0 512.000000 512.000000"
                          preserveAspectRatio="xMidYMid meet"
                          style={{ marginTop: '5px' }}
                        >
                          <g
                            transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                            fill="#000000"
                            stroke="none"
                          >
                            <path d="M3220 5105 c-265 -36 -490 -132 -705 -300 -477 -373 -670 -1011 -480 -1589 79 -244 235 -480 425 -643 190 -164 421 -279 654 -327 224 -47 655 -47 855 0 l64 15 202 -201 c194 -192 204 -200 241 -200 41 0 74 21 93 57 7 14 11 119 11 318 l0 296 98 97 c142 140 249 294 320 457 262 607 84 1316 -433 1720 -218 171 -441 264 -714 301 -133 17 -500 17 -631 -1z m686 -208 c389 -83 707 -327 885 -678 39 -79 93 -243 110 -339 17 -92 17 -341 0 -430 -56 -301 -202 -547 -451 -762 l-65 -56 -3 -217 -3 -218 -139 138 -139 137 -43 -5 c-24 -2 -88 -15 -143 -28 -90 -21 -125 -23 -360 -23 -350 -1 -475 23 -691 129 -355 174 -598 490 -680 885 -22 105 -25 341 -5 450 70 391 323 729 680 910 87 43 249 95 341 109 41 6 86 13 100 15 63 11 538 -3 606 -17z" />
                            <path d="M3455 4402 c-86 -26 -122 -47 -182 -108 -74 -74 -116 -165 -121 -262 -4 -69 -3 -75 24 -103 36 -38 90 -40 132 -4 23 20 31 37 40 91 13 81 46 134 105 168 91 54 199 41 270 -32 121 -125 74 -308 -97 -371 -137 -51 -156 -87 -156 -299 0 -92 4 -161 11 -176 7 -14 27 -32 46 -41 31 -15 40 -15 72 -3 58 22 71 60 71 206 0 91 3 122 13 122 33 0 137 62 183 109 208 212 145 554 -124 678 -93 43 -196 52 -287 25z" />
                            <path d="M3543 3053 c-35 -7 -73 -59 -73 -100 0 -77 103 -124 159 -72 77 72 18 191 -86 172z" />
                            <path d="M555 3364 c-38 -8 -112 -36 -164 -60 -78 -38 -109 -60 -181 -132 -75 74 -94 -101 -133 -182 -79 -164 -77 -139 -77 -1080 0 -941 -2 -916 77 -1080 39 -81 58 -108 133 -182 72 -72 103 -94 181 -131 145 -71 194 -77 576 -77 l328 0 190 -191 c251 -253 273 -268 338 -238 50 23 57 52 57 248 l0 181 520 0 c596 0 614 2 770 77 80 38 109 59 181 132 73 72 94 101 132 181 74 153 78 191 75 648 l-3 394 -34 30 c-28 25 -39 29 -70 24 -23 -3 -46 -17 -63 -36 l-28 -30 0 -388 c0 -426 -2 -448 -61 -564 -38 -76 -127 -167 -199 -203 -124 -63 -80 -59 -747 -65 l-613 -5 -27 -28 c-27 -26 -28 -33 -33 -143 l-5 -115 -130 131 c-71 73 -139 138 -150 146 -16 11 -89 14 -385 14 -292 0 -377 3 -423 15 -185 48 -324 187 -372 372 -22 85 -22 1681 0 1766 48 185 187 324 372 372 47 12 152 15 605 15 l548 0 32 29 c27 24 33 36 33 71 0 35 -6 47 -33 71 l-32 29 -558 -1 c-450 0 -570 -3 -627 -15z" />
                            <path d="M605 2571 c-64 -27 -81 -110 -32 -158 l27 -28 765 -3 764 -2 33 29 c27 24 33 36 33 71 0 35 -6 47 -33 71 l-32 29 -753 -1 c-413 0 -761 -4 -772 -8z" />
                            <path d="M605 2011 c-64 -27 -81 -110 -32 -158 l27 -28 1090 -3 1089 -2 33 29 c27 24 33 36 33 71 0 35 -6 47 -33 71 l-32 29 -1078 -1 c-592 0 -1086 -4 -1097 -8z" />
                            <path d="M605 1451 c-64 -27 -81 -110 -32 -158 l27 -28 888 -2 c694 -2 892 0 912 10 14 7 33 29 43 50 18 36 18 38 0 74 -10 21 -29 43 -43 50 -19 10 -222 13 -900 12 -481 0 -884 -4 -895 -8z" />
                            <path d="M2715 1451 c-64 -27 -81 -110 -32 -158 60 -61 162 -19 162 67 0 66 -72 116 -130 91z" />
                          </g>
                        </svg>
                        <p>
                          Unanswered question:{' '}
                          {
                            conversationSummary.unanswered_question
                              .missed_question
                          }
                        </p>
                      </div>
                    ) : // for older Version
                    conversationSummary.has_unanswered_question !== undefined &&
                      conversationSummary.has_unanswered_question ? (
                      <div className="con-followuup-item">
                        <svg
                          version="1.0"
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          viewBox="0 0 512.000000 512.000000"
                          preserveAspectRatio="xMidYMid meet"
                          style={{ marginTop: '5px' }}
                        >
                          <g
                            transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                            fill="#000000"
                            stroke="none"
                          >
                            <path d="M3220 5105 c-265 -36 -490 -132 -705 -300 -477 -373 -670 -1011 -480 -1589 79 -244 235 -480 425 -643 190 -164 421 -279 654 -327 224 -47 655 -47 855 0 l64 15 202 -201 c194 -192 204 -200 241 -200 41 0 74 21 93 57 7 14 11 119 11 318 l0 296 98 97 c142 140 249 294 320 457 262 607 84 1316 -433 1720 -218 171 -441 264 -714 301 -133 17 -500 17 -631 -1z m686 -208 c389 -83 707 -327 885 -678 39 -79 93 -243 110 -339 17 -92 17 -341 0 -430 -56 -301 -202 -547 -451 -762 l-65 -56 -3 -217 -3 -218 -139 138 -139 137 -43 -5 c-24 -2 -88 -15 -143 -28 -90 -21 -125 -23 -360 -23 -350 -1 -475 23 -691 129 -355 174 -598 490 -680 885 -22 105 -25 341 -5 450 70 391 323 729 680 910 87 43 249 95 341 109 41 6 86 13 100 15 63 11 538 -3 606 -17z" />
                            <path d="M3455 4402 c-86 -26 -122 -47 -182 -108 -74 -74 -116 -165 -121 -262 -4 -69 -3 -75 24 -103 36 -38 90 -40 132 -4 23 20 31 37 40 91 13 81 46 134 105 168 91 54 199 41 270 -32 121 -125 74 -308 -97 -371 -137 -51 -156 -87 -156 -299 0 -92 4 -161 11 -176 7 -14 27 -32 46 -41 31 -15 40 -15 72 -3 58 22 71 60 71 206 0 91 3 122 13 122 33 0 137 62 183 109 208 212 145 554 -124 678 -93 43 -196 52 -287 25z" />
                            <path d="M3543 3053 c-35 -7 -73 -59 -73 -100 0 -77 103 -124 159 -72 77 72 18 191 -86 172z" />
                            <path d="M555 3364 c-38 -8 -112 -36 -164 -60 -78 -38 -109 -60 -181 -132 -75 74 -94 -101 -133 -182 -79 -164 -77 -139 -77 -1080 0 -941 -2 -916 77 -1080 39 -81 58 -108 133 -182 72 -72 103 -94 181 -131 145 -71 194 -77 576 -77 l328 0 190 -191 c251 -253 273 -268 338 -238 50 23 57 52 57 248 l0 181 520 0 c596 0 614 2 770 77 80 38 109 59 181 132 73 72 94 101 132 181 74 153 78 191 75 648 l-3 394 -34 30 c-28 25 -39 29 -70 24 -23 -3 -46 -17 -63 -36 l-28 -30 0 -388 c0 -426 -2 -448 -61 -564 -38 -76 -127 -167 -199 -203 -124 -63 -80 -59 -747 -65 l-613 -5 -27 -28 c-27 -26 -28 -33 -33 -143 l-5 -115 -130 131 c-71 73 -139 138 -150 146 -16 11 -89 14 -385 14 -292 0 -377 3 -423 15 -185 48 -324 187 -372 372 -22 85 -22 1681 0 1766 48 185 187 324 372 372 47 12 152 15 605 15 l548 0 32 29 c27 24 33 36 33 71 0 35 -6 47 -33 71 l-32 29 -558 -1 c-450 0 -570 -3 -627 -15z" />
                            <path d="M605 2571 c-64 -27 -81 -110 -32 -158 l27 -28 765 -3 764 -2 33 29 c27 24 33 36 33 71 0 35 -6 47 -33 71 l-32 29 -753 -1 c-413 0 -761 -4 -772 -8z" />
                            <path d="M605 2011 c-64 -27 -81 -110 -32 -158 l27 -28 1090 -3 1089 -2 33 29 c27 24 33 36 33 71 0 35 -6 47 -33 71 l-32 29 -1078 -1 c-592 0 -1086 -4 -1097 -8z" />
                            <path d="M605 1451 c-64 -27 -81 -110 -32 -158 l27 -28 888 -2 c694 -2 892 0 912 10 14 7 33 29 43 50 18 36 18 38 0 74 -10 21 -29 43 -43 50 -19 10 -222 13 -900 12 -481 0 -884 -4 -895 -8z" />
                            <path d="M2715 1451 c-64 -27 -81 -110 -32 -158 60 -61 162 -19 162 67 0 66 -72 116 -130 91z" />
                          </g>
                        </svg>
                        <p>
                          Unanswered question:{' '}
                          {conversationSummary.missed_question}
                        </p>
                      </div>
                    ) : (
                      ''
                    )}
                    {conversationSummary.human_hand_over &&
                    conversationSummary.human_hand_over ? (
                      <div className="con-followuup-item">
                        <svg
                          version="1.0"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 512.000000 512.000000"
                          preserveAspectRatio="xMidYMid meet"
                        >
                          <g
                            transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                            fill="#000000"
                            stroke="none"
                          >
                            <path d="M1471 4605 c-212 -60 -349 -268 -312 -476 44 -253 298 -414 537 -341 125 38 210 112 267 232 39 82 49 205 23 293 -35 120 -140 234 -256 278 -72 27 -188 34 -259 14z m229 -170 c86 -44 150 -146 150 -240 0 -96 -69 -203 -157 -246 -135 -66 -309 3 -368 145 -18 42 -20 140 -3 187 54 158 230 229 378 154z" />
                            <path d="M3470 4604 c-119 -32 -213 -113 -273 -233 -30 -62 -32 -72 -32 -176 0 -99 3 -116 28 -169 55 -119 146 -199 266 -236 148 -47 294 -12 412 98 173 160 182 424 19 596 -109 115 -268 161 -420 120z m178 -147 c69 -18 125 -59 163 -119 27 -41 33 -62 37 -122 5 -87 -6 -128 -53 -189 -73 -95 -220 -130 -328 -78 -88 43 -157 150 -157 246 0 91 63 196 144 237 75 39 118 44 194 25z" />
                            <path d="M1328 3681 c-31 -10 -72 -28 -92 -40 -56 -35 -133 -126 -158 -189 l-23 -57 0 -1385 0 -1385 27 -57 c29 -62 100 -145 135 -159 15 -5 76 0 175 17 152 25 152 25 198 5 71 -30 123 -35 164 -16 47 23 132 115 159 172 22 48 22 48 25 856 l2 808 33 -7 c17 -4 151 -34 297 -67 146 -32 285 -59 310 -59 25 0 178 29 340 66 162 36 296 66 297 66 1 0 4 -363 5 -807 3 -808 3 -808 25 -856 27 -57 112 -149 159 -172 25 -12 47 -15 77 -10 52 9 118 37 135 58 12 14 24 12 125 -24 147 -53 188 -51 253 12 25 24 59 73 77 109 l32 65 0 1385 0 1385 -24 60 c-18 44 -42 78 -90 126 -76 76 -146 108 -251 116 -176 14 -401 -107 -486 -260 l-29 -52 -5 -324 -5 -323 -318 -103 -317 -103 -318 103 -317 103 -5 324 -5 323 -29 52 c-42 76 -131 157 -218 198 -140 66 -252 80 -360 46z m235 -157 c67 -22 159 -86 193 -135 l29 -42 5 -351 c3 -193 9 -356 13 -363 4 -7 147 -58 317 -113 338 -110 315 -97 323 -182 1 -21 3 -38 2 -38 0 0 -148 32 -330 71 -181 38 -365 77 -407 86 l-78 16 0 385 c0 382 0 386 -22 409 -28 30 -77 31 -105 1 -20 -22 -21 -35 -24 -455 -4 -422 -3 -433 16 -452 14 -14 61 -29 155 -49 l135 -28 3 -775 c2 -547 0 -789 -8 -827 -13 -58 -63 -122 -97 -122 -11 0 -30 12 -44 26 l-24 26 -5 695 -5 695 -25 20 c-30 24 -77 18 -102 -13 -17 -20 -18 -69 -18 -719 l0 -697 -96 -16 c-97 -16 -97 -16 -115 6 -50 59 -49 26 -49 1426 0 857 4 1321 11 1351 19 86 91 159 174 179 47 11 111 6 178 -15z m2254 1 c51 -21 111 -91 128 -148 13 -44 15 -224 15 -1362 0 -1420 2 -1371 -53 -1437 l-22 -28 -90 34 -90 33 -5 691 c-5 758 -2 715 -66 728 -21 4 -37 0 -54 -14 l-25 -20 -5 -695 -5 -695 -24 -26 c-14 -14 -33 -26 -44 -26 -34 0 -84 64 -97 122 -8 38 -10 280 -8 827 l3 774 134 29 c73 15 140 33 148 40 32 26 34 63 27 481 -7 389 -9 422 -26 439 -28 28 -82 24 -107 -8 -20 -26 -21 -37 -21 -409 l0 -382 -387 -82 c-214 -45 -397 -85 -409 -87 -18 -5 -20 -1 -17 33 8 86 -13 74 296 173 338 109 335 108 347 131 6 10 10 153 10 341 0 191 4 338 10 360 21 76 156 174 270 197 52 11 121 5 167 -14z" />
                          </g>
                        </svg>
                        <p>Human handover requested</p>
                      </div>
                    ) : null}
                    {conversationSummary?.remaining_actions ? (
                      <div className="con-followuup-item">
                        <svg
                          version="1.0"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 512.000000 512.000000"
                          preserveAspectRatio="xMidYMid meet"
                        >
                          <g
                            transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                            fill="#000000"
                            stroke="none"
                          >
                            <path d="M3980 4566 c-167 -36 -291 -165 -321 -334 -35 -196 94 -398 290 -456 160 -47 351 20 444 156 56 81 70 130 71 238 1 87 -2 101 -31 162 -61 129 -174 216 -308 238 -71 12 -75 12 -145 -4z m169 -168 c44 -13 107 -71 132 -121 78 -152 -23 -336 -194 -354 -134 -14 -252 81 -272 217 -16 118 77 246 196 269 47 9 83 6 138 -11z" />
                            <path d="M2520 3881 c-179 -104 -342 -205 -363 -225 -21 -21 -51 -63 -65 -94 -36 -76 -38 -202 -5 -274 30 -65 95 -133 159 -164 64 -31 167 -42 230 -25 23 6 140 68 260 137 l219 126 72 -13 72 -14 -200 -345 c-110 -190 -207 -369 -216 -397 -14 -45 -33 -69 -128 -163 -77 -75 -119 -110 -135 -110 -12 0 -128 60 -257 134 -262 151 -305 167 -407 148 -108 -20 -194 -82 -244 -177 -24 -45 -27 -61 -27 -150 0 -91 2 -104 29 -151 15 -29 44 -68 65 -87 44 -43 737 -444 801 -464 65 -21 182 -12 245 17 36 17 100 73 226 198 l177 173 158 -91 c88 -51 167 -99 177 -107 16 -15 17 -50 17 -473 0 -500 1 -513 59 -601 60 -90 161 -141 278 -141 163 0 295 115 322 282 14 83 14 964 1 1080 -7 67 -18 103 -49 166 -53 106 -112 160 -279 258 -72 43 -132 82 -132 87 0 5 48 92 107 194 l106 185 131 -134 131 -133 295 -79 c259 -69 305 -79 375 -78 114 2 202 47 263 137 97 140 75 318 -54 436 -61 56 -81 64 -379 142 l-160 42 -147 151 c-116 119 -150 159 -158 191 -37 138 -78 177 -353 334 l-218 124 -321 68 c-177 38 -328 69 -337 69 -9 -1 -162 -86 -341 -189z m662 -40 c152 -33 287 -65 299 -72 75 -39 387 -223 403 -237 30 -28 48 -73 48 -123 0 -44 -20 -83 -273 -521 -293 -506 -299 -519 -250 -559 13 -10 88 -56 168 -101 166 -95 233 -149 271 -222 l27 -51 3 -566 3 -565 -23 -34 c-45 -66 -114 -96 -185 -80 -51 12 -84 39 -110 90 -23 44 -23 47 -23 498 0 331 -3 466 -12 496 -20 67 -78 112 -337 260 -134 77 -259 155 -279 174 -78 78 -110 211 -75 312 10 30 115 221 232 423 117 203 219 383 226 400 11 26 11 38 0 63 -16 39 -37 47 -219 79 l-148 26 -187 -107 c-285 -165 -301 -174 -347 -174 -92 0 -174 81 -174 172 0 39 27 105 52 126 31 25 604 352 618 352 9 0 140 -27 292 -59z m1145 -855 c10 -3 119 -32 242 -66 129 -35 236 -69 253 -82 35 -24 68 -89 68 -133 0 -38 -31 -104 -61 -132 -29 -26 -71 -43 -107 -43 -15 0 -153 34 -307 75 l-279 75 -99 97 c-54 54 -112 115 -128 135 l-30 37 88 152 87 151 127 -130 c70 -71 135 -133 146 -136z m-2426 -569 c35 -18 149 -82 254 -142 l190 -110 70 0 c84 1 107 11 195 92 l64 60 38 -77 c28 -57 54 -92 102 -137 l64 -61 -157 -155 c-169 -167 -184 -176 -272 -164 -27 3 -148 68 -382 203 -188 109 -352 205 -364 213 -61 44 -82 154 -42 220 56 93 135 112 240 58z" />
                            <path d="M95 4025 c-34 -33 -32 -70 4 -106 l30 -29 719 2 c692 3 721 4 741 22 28 26 29 88 1 116 -20 20 -33 20 -745 20 l-726 0 -24 -25z" />
                            <path d="M372 3474 c-32 -22 -44 -58 -31 -91 20 -54 -8 -52 720 -53 l676 0 21 23 c30 32 29 81 -3 112 l-24 25 -668 0 c-597 0 -671 -2 -691 -16z" />
                            <path d="M95 2895 c-34 -33 -32 -70 4 -106 l30 -29 719 2 c692 3 721 4 741 22 29 26 29 88 -1 116 -21 20 -31 20 -745 20 l-724 0 -24 -25z" />
                            <path d="M380 2347 c-53 -27 -58 -111 -10 -137 12 -6 189 -10 455 -10 l436 0 24 25 c33 33 32 70 -4 106 l-29 29 -424 0 c-321 0 -429 -3 -448 -13z" />
                            <path d="M95 1765 c-39 -38 -27 -102 22 -124 17 -8 237 -11 741 -11 783 0 750 -2 772 56 11 28 -2 71 -28 90 -14 11 -164 13 -750 14 l-733 0 -24 -25z" />
                            <path d="M380 1217 c-53 -27 -58 -111 -10 -137 12 -6 385 -10 1018 -10 l999 0 21 23 c22 23 28 60 16 92 -18 46 -2 45 -1041 45 -768 0 -983 -3 -1003 -13z" />
                          </g>
                        </svg>
                        <p>
                          <IntlMessages id="content.actionneeded" />{' '}
                          <Button
                            size="xs"
                            outline
                            color="primary"
                            onClick={tickettoggle}
                            className="ml-1 btn-round"
                          >
                            <FontAwesomeIcon
                              icon={faTicketAlt}
                            ></FontAwesomeIcon>{' '}
                            <IntlMessages id="dashboards.tickets" />
                          </Button>
                        </p>
                      </div>
                    ) : null}
                    {conversationSummary.unanswered_question &&
                    conversationSummary.unanswered_question
                      .has_unanswered_question === false &&
                    conversationSummary.human_hand_over === false &&
                    conversationSummary.remaining_actions === false ? (
                      <div className="con-followuup-item">
                        <i className="iconsminds-security-block"></i>
                        <p>
                          No action identified{' '}
                          {selectedChat.status === 'Opened' ? (
                            <Button
                              size="xs"
                              outline
                              color="primary"
                              onClick={() => handleStatusSubmit('Closed')}
                              className="mx-1 btn-round"
                            >
                              <FontAwesomeIcon
                                icon={faArrowDown}
                              ></FontAwesomeIcon>{' '}
                              Close
                            </Button>
                          ) : (
                            <Button
                              size="xs"
                              outline
                              color="primary"
                              onClick={() => handleStatusSubmit('Opened')}
                              className="mx-1 btn-round"
                            >
                              <i className="iconsminds-right-1"></i> Open
                            </Button>
                          )}
                        </p>
                      </div>
                    ) : //for older version
                    conversationSummary.has_unanswered_question &&
                      conversationSummary.has_unanswered_question === false &&
                      conversationSummary.human_hand_over === false &&
                      conversationSummary.remaining_actions === false ? (
                      <div className="con-followuup-item">
                        <i className="iconsminds-security-block"></i>
                        <p>
                          No action identified{' '}
                          {selectedChat.status === 'Opened' ? (
                            <Button
                              size="xs"
                              outline
                              color="primary"
                              onClick={() => handleStatusSubmit('Closed')}
                              className="mx-1 btn-round"
                            >
                              <FontAwesomeIcon
                                icon={faArrowDown}
                              ></FontAwesomeIcon>{' '}
                              Close
                            </Button>
                          ) : (
                            <Button
                              size="xs"
                              outline
                              color="primary"
                              onClick={() => handleStatusSubmit('Opened')}
                              className="mx-1 btn-round"
                            >
                              <i className="iconsminds-right-1"></i> Open
                            </Button>
                          )}
                        </p>
                      </div>
                    ) : null}
                  </div>
                </CardBody>
              </Card>
            </div>
          </Fragment>
        )
      )}
    </Fragment>
  );
};

export default ConversationSummary;
